import { isRoundedPriceEnabled } from '@/infrastructure/Configuration'
import { roundPrice } from '@/infrastructure/Utils'

export const loadHotelJsonLd = (hotel, rooms, selectedCurrency, checkInDate, checkOutDate) => {
  const jsonLdHotel = document.createElement('script')
  jsonLdHotel.setAttribute('type', 'application/ld+json')
  jsonLdHotel.textContent = JSON.stringify(
    hotelSchema(hotel, rooms, selectedCurrency, checkInDate, checkOutDate),
    null,
    ''
  )
  document.head.appendChild(jsonLdHotel)
}

export const hotelSchema = (hotel, rooms, selectedCurrency, checkInDate, checkOutDate) => {
  const makesOffer = rooms.flatMap(room => {
    let roomStays = []
    if (room.groups?.length) {
      roomStays = room.groups.reduce((acc, group) => {
        if (group.staysMember && group.staysMember.length > 0) {
          return acc.concat(group.staysMember)
        } else if (group.staysPublic && group.staysPublic.length > 0) {
          return acc.concat(group.staysPublic)
        }
        return acc
      }, [])
    } else {
      roomStays = room.stays
    }

    return roomStays
      .map(stay => {
        return {
          '@type': ['Offer', 'LodgingReservation'],
          name: room.name,
          identifier: stay.memberOnly ? 'rate-member-only' : 'non-rate-member',
          availability: 'https://schema.org/InStock',
          checkinTime: new Date(checkInDate + ' ' + hotel.checkInTime),
          checkoutTime: new Date(checkOutDate + ' ' + hotel.checkOutTime),
          priceSpecification: {
            valueAddedTaxIncluded: stay.includesTaxes,
            '@type': 'CompoundPriceSpecification',
            price: isRoundedPriceEnabled()
              ? roundPrice(stay.cash?.price?.amount)
              : stay.cash?.price?.amount,
            priceCurrency: selectedCurrency?.code || stay.cash?.price?.currency
          }
        }
      })
      .sort(
        (a, b) =>
          a.identifier.localeCompare(b.identifier) ||
          a.priceSpecification.price - b.priceSpecification.price
      )
  })

  return {
    '@context': 'https://schema.org',
    '@type': 'Hotel',
    name: hotel.name,
    identifier: hotel.code,
    image: [hotel.image.url],
    amenityFeature:
      hotel.services?.map(service => ({
        '@type': 'LocationFeatureSpecification',
        name: service.name,
        value: true
      })) || [],
    address: {
      '@type': 'PostalAddress',
      addressCountry: hotel.address.countryCode,
      addressLocality: hotel.address.city,
      addressRegion: hotel.address.country,
      postalCode: hotel.address.zip,
      streetAddress: hotel.address.street
    },
    makesOffer
  }
}
